import { TransversalBar } from "../../components/pagesComponents/transversalBar";
import { RegisterAddressPersonPage } from "../../components/pagesComponents/registerAddressPersonPage";
import { Container } from "./style";

export function RegisterAddressPerson() {
	return (
		<Container>
			<TransversalBar />
			<RegisterAddressPersonPage />
		</Container>
	);
}
